import { RootState } from '@store/store';

// Get the header info.
export const getUserHeaderInfo = (state: RootState) => state.user.headerInfo;
